import axios from "axios";
// import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addCommissionSlab = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "ADD_COMMISSION_SLAB_REQUEST" });

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };

            const { data } = await axios.post(
                `${BASE_URL}/commission-slab/add`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "ADD_COMMISSION_SLAB_SUCCESS", payload: data });
            } else {
                dispatch({ type: "ADD_COMMISSION_SLAB_FAILED", payload: data });
            }
            return data;
        } catch (error) {
            dispatch({
                type: "ADD_COMMISSION_SLAB_FAILED",
                payload: error?.response?.data?.message,
            });
            return error?.response?.data;
        } finally {
            dispatch({ type: "STOP_LOADING" });
        }
    };
};

export const updateCommissionSlab = (id, payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "UPDATE_COMMISSION_SLAB_REQUEST" });

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };

            const { data } = await axios.put(
                `${BASE_URL}/commission-slab/update/${id}`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "UPDATE_COMMISSION_SLAB_SUCCESS", payload: data });
            } else {
                dispatch({ type: "UPDATE_COMMISSION_SLAB_FAILED", payload: data });
            }
            return data;
        } catch (error) {
            dispatch({
                type: "UPDATE_COMMISSION_SLAB_FAILED",
                payload: error?.response?.data?.message,
            });
            return error?.response?.data;
        } finally {
            dispatch({ type: "STOP_LOADING" });
        }
    };
};

export const getCommissionSlab = (project_id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "GET_COMMISSION_SLAB_REQUEST" });

            const { data } = await axios.get(
                `${BASE_URL}/commission-slab/project/${project_id}`
            );

            if (data.statusCode === 200) {
                dispatch({ type: "GET_COMMISSION_SLAB_SUCCESS", payload: data });
            } else {
                dispatch({ type: "GET_COMMISSION_SLAB_FAILED", payload: data });
            }
        } catch (error) {
            dispatch({
                type: "GET_COMMISSION_SLAB_FAILED",
                payload: error?.response?.data?.message,
            });
            return error?.response?.data;
        } finally {
            dispatch({ type: "STOP_LOADING" });
        }
    };
};

// NEW
export const getCommissionSlabByProperty = (properties_id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "GET_COMMISSION_SLAB_REQUEST" });

            const { data } = await axios.get(
                `${BASE_URL}/commission-slab/property/${properties_id}`
            );

            if (data.statusCode === 200) {
                dispatch({ type: "GET_COMMISSION_SLAB_SUCCESS", payload: data });
            } else {
                dispatch({ type: "GET_COMMISSION_SLAB_FAILED", payload: data });
            }
        } catch (error) {
            dispatch({
                type: "GET_COMMISSION_SLAB_FAILED",
                payload: error?.response?.data?.message,
            });
            return error?.response?.data;
        } finally {
            dispatch({ type: "STOP_LOADING" });
        }
    };
};

export const listCommissionSlab = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: "LIST_COMMISSION_SLAB_REQUEST" });

            const { data } = await axios.get(`${BASE_URL}/commission-slab/list`);

            if (data.statusCode === 200) {
                dispatch({ type: "LIST_COMMISSION_SLAB_SUCCESS", payload: data });
            } else {
                dispatch({ type: "LIST_COMMISSION_SLAB_FAILED", payload: data });
            }
        } catch (error) {
            dispatch({
                type: "LIST_COMMISSION_SLAB_FAILED",
                payload: error?.response?.data?.message,
            });
            return error?.response?.data;
        } finally {
            dispatch({ type: "STOP_LOADING" });
        }
    };
};

export const listProjectsWithSlabForFranchise = (franchise_manager_id, search = "") => {
    return async (dispatch) => {
        try {
            dispatch({ type: "LIST_PROJECTS_WITH_SLAB_REQUEST" });

            const { data } = await axios.get(
                `${BASE_URL}/commission-slab/franchise/${franchise_manager_id}/projects`,
                { params: search ? { search } : {} }
            );

            if (data.statusCode === 200) {
                dispatch({ type: "LIST_PROJECTS_WITH_SLAB_SUCCESS", payload: data });
            } else {
                dispatch({ type: "LIST_PROJECTS_WITH_SLAB_FAILED", payload: data });
            }
            return data;
        } catch (error) {
            dispatch({
                type: "LIST_PROJECTS_WITH_SLAB_FAILED",
                payload: error?.response?.data?.message,
            });
            return error?.response?.data;
        } finally {
            dispatch({ type: "STOP_LOADING" });
        }
    };
};